declare var moment: any;

export default class ShadowInput {
  public static readonly IS_TOUCH_DEVICE = window.matchMedia('( pointer: coarse )').matches;

  constructor() {
    [].slice.call(document.querySelectorAll('input[data-shadow-input]')).forEach(($input: HTMLInputElement) => {
      const $shadow = document.querySelector(`input${$input.getAttribute('data-shadow-input')}`) as HTMLInputElement;

      if (!ShadowInput.IS_TOUCH_DEVICE) {
        $shadow.style.display = 'none';

        return;
      }

      if ($input.value.length) {
        switch ($shadow.getAttribute('type')) {
        case 'date':
          const dateComponents = $input.value.split('-');

          $shadow.value = `${dateComponents[2]}-${dateComponents[1]}-${dateComponents[0]}`;
          break;

        default:
          $shadow.value = $input.value;
        }
      }

      $shadow.style.height = `${$input.clientHeight}px`;
      $shadow.style.width = `${$input.clientWidth}px`;
      $shadow.style.left = `${$input.offsetLeft}px`;
      $shadow.style.top = `${$input.offsetTop}px`;

      // Add the event listeners.
      $shadow.addEventListener('change', () => {
        switch ($shadow.getAttribute('type')) {
        case 'date':
          if (!moment($shadow.value).isValid()) {
            $input.value = '';
            return;
          }

          $input.value = moment($shadow.value).format('DD-MM-YYYY');
          break;

        default:
          $input.value = $shadow.value;
        }
      });
    });
  }
}
